module.exports = __webpack_public_path__ + "img/Ele1.4f035cef.jpg";